import {
  CaretDownIcon,
  Menu,
  NavBarItem,
  NavBarLink,
  useOpenable,
} from '@execonline-inc/execonline-ui';
import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { Route, RouteChildrenProps } from 'react-router-dom';
import { handleEnterKeyPress } from '../../../../Accessibility/KeyboardEvents';
import { discoveryStore } from '../../../../DiscoveryStore';
import useDiscoveryStore from '../../../../DiscoveryStore/UseDiscoveryStore';
import { T } from '../../../../Translations';
import { NavigationMenuItems } from '../Common';
import { dropdownMenuItems } from './Types';
import { sortByNameNaturally } from '../../../../Collections';

const menuId = 'useCaseNavigationMenu';

function UseCaseDropdownMenu() {
  useDiscoveryStore();
  const anchorElementRef = useRef<HTMLAnchorElement>(null);
  const { isOpen, onClose, onOpenChange } = useOpenable();

  /**
   * Converts learning collections to dropdown menu items and sorts them alphabetically
   * Uses natural alphanumeric sorting to handle numbers properly (e.g., "Course 2" before "Course 10")
   */
  const getSortedLearningCollectionsForDropdown = () => {
    const unsortedItems = dropdownMenuItems(discoveryStore.learningCollections);
    return sortByNameNaturally(unsortedItems);
  };

  return (
    <>
      <Route
        path="/register"
        children={({ match }: RouteChildrenProps<{}>) => {
          return (
            <NavBarItem
              data-testid="menu-bar_learning-collections-menu-item"
              data-intercom-target="learning-collections-menu"
            >
              <NavBarLink
                data-testid="menu-bar_learning-collections-menu-item-link"
                id={menuId}
                ref={anchorElementRef}
                className="flex flex-shrink-0 items-center"
                active={fromNullable(match).isJust()}
                aria-label="Learning Collections"
                aria-haspopup="menu"
                aria-expanded={isOpen}
                onClick={onOpenChange}
                onKeyDown={handleEnterKeyPress(onOpenChange)}
              >
                <T kind="Learning Collections" />
                <CaretDownIcon className="ml-2" size="xs" color="inherit" />
              </NavBarLink>
              <Menu
                data-testid="learning-collections-menu_dropdown"
                aria-labelledby={menuId}
                className="max-h-72 max-w-[28rem]"
                open={isOpen}
                anchorElement={anchorElementRef.current}
                onClose={onClose}
                data-intercom-target="learning-collections-dropdown-menu"
              >
                <NavigationMenuItems items={getSortedLearningCollectionsForDropdown()} />
              </Menu>
            </NavBarItem>
          );
        }}
      />
    </>
  );
}

export default observer(UseCaseDropdownMenu);
